export * from './ecall-edit.component';
export * from './ecall-edit.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-edit/index.ts